window.SgCart = (function () {
  var NOTE_DEBOUNCE = 600;
  var drawer, overlay, itemsEl, subtotalEl, countLabelEl, countEls;
  var shippingEl, shippingFillEl, shippingMessageEl, shippingThreshold, progressTemplate, unlockedMessage;
  var noteEl, noteTimer;

  function init() {
    drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    overlay = document.querySelector('[data-cart-overlay]');
    itemsEl = drawer.querySelector('[data-cart-items]');
    subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    countLabelEl = drawer.querySelector('[data-cart-count-label]');
    countEls = document.querySelectorAll('[data-cart-count]');

    shippingEl = drawer.querySelector('[data-free-shipping]');
    if (shippingEl) {
      shippingFillEl = shippingEl.querySelector('[data-free-shipping-fill]');
      shippingMessageEl = shippingEl.querySelector('[data-free-shipping-message]');
      shippingThreshold = parseInt(shippingEl.dataset.threshold, 10) || 0;
      progressTemplate = shippingEl.dataset.progressTemplate;
      unlockedMessage = shippingEl.dataset.unlockedMessage;
    }

    noteEl = drawer.querySelector('[data-cart-note]');
    if (noteEl) {
      noteEl.addEventListener('input', function () {
        clearTimeout(noteTimer);
        var value = noteEl.value;
        noteTimer = setTimeout(function () {
          updateNote(value);
        }, NOTE_DEBOUNCE);
      });
    }

    drawer.querySelector('[data-cart-close]').addEventListener('click', close);
    drawer.querySelector('[data-cart-continue]').addEventListener('click', close);
    overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('submit', onFormSubmit);
    document.addEventListener('cart:open', open);
  }

  function onDocumentClick(event) {
    var openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      open();
      return;
    }

    var qtyBtn = event.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var item = qtyBtn.closest('[data-cart-item]');
      var input = item.querySelector('[data-cart-qty-value]');
      var step = qtyBtn.dataset.cartQty === 'plus' ? 1 : -1;
      var newQty = parseInt(input.textContent, 10) + step;
      updateItem(item.dataset.key, newQty);
      return;
    }

    var removeBtn = event.target.closest('[data-cart-remove]');
    if (removeBtn) {
      removeItem(removeBtn.closest('[data-cart-item]').dataset.key);
    }
  }

  function onFormSubmit(event) {
    var form = event.target.closest('[data-ajax-cart]');
    if (!form) return;

    event.preventDefault();
    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(open)
      .catch(function (error) {
        console.error('SgCart: add to cart failed', error);
      });
  }

  function open() {
    fetchCart().then(function () {
      drawer.classList.add('cart-drawer--open');
      overlay.classList.add('cart-overlay--visible');
      drawer.setAttribute('aria-hidden', 'false');
    });
  }

  function close() {
    drawer.classList.remove('cart-drawer--open');
    overlay.classList.remove('cart-overlay--visible');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(render);
  }

  function add(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(open);
  }

  function updateItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
      .then(function (response) {
        return response.json();
      })
      .then(render);
  }

  function removeItem(key) {
    return updateItem(key, 0);
  }

  function updateNote(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    }).catch(function (error) {
      console.error('SgCart: note update failed', error);
    });
  }

  function renderShippingProgress(totalPrice) {
    if (!shippingEl) return;

    var unlocked = shippingThreshold <= 0 || totalPrice >= shippingThreshold;
    var percent = shippingThreshold > 0 ? Math.min(100, (totalPrice / shippingThreshold) * 100) : 100;

    shippingEl.classList.toggle('cart-drawer__shipping--unlocked', unlocked);
    if (shippingFillEl) shippingFillEl.style.width = percent + '%';

    if (shippingMessageEl) {
      if (unlocked) {
        shippingMessageEl.textContent = unlockedMessage;
      } else {
        var remaining = formatMoney(shippingThreshold - totalPrice);
        shippingMessageEl.textContent = progressTemplate.replace('{amount}', remaining);
      }
    }
  }

  function render(cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
    });
    if (countLabelEl) countLabelEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    renderShippingProgress(cart.total_price);
    if (noteEl && document.activeElement !== noteEl) noteEl.value = cart.note || '';

    if (!itemsEl) return;

    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">' + drawer.dataset.emptyText + '</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(renderItem).join('');
  }

  function renderItem(item) {
    var variantMarkup = '';
    if (item.variant_title && item.variant_title.indexOf('Default') === -1) {
      variantMarkup = '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>';
    }

    return (
      '<div class="cart-drawer__item" data-cart-item data-key="' +
      item.key +
      '">' +
      '<img class="cart-drawer__item-image" src="' +
      item.image +
      '&width=160" width="80" height="80" loading="lazy" alt="' +
      escapeHtml(item.product_title) +
      '">' +
      '<div class="cart-drawer__item-info">' +
      '<p class="cart-drawer__item-title">' +
      escapeHtml(item.product_title) +
      '</p>' +
      variantMarkup +
      '<div class="cart-drawer__item-row">' +
      '<div class="cart-drawer__stepper">' +
      '<button type="button" class="cart-drawer__qty-btn" data-cart-qty="minus" aria-label="Decrease quantity">−</button>' +
      '<span class="cart-drawer__qty-value" data-cart-qty-value>' +
      item.quantity +
      '</span>' +
      '<button type="button" class="cart-drawer__qty-btn" data-cart-qty="plus" aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<span class="cart-drawer__item-price">' +
      formatMoney(item.final_line_price) +
      '</span>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="cart-drawer__remove" data-cart-remove aria-label="Remove">×</button>' +
      '</div>'
    );
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return (cents / 100).toLocaleString(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency
    });
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  document.addEventListener('DOMContentLoaded', init);

  return {
    open: open,
    close: close,
    fetch: fetchCart,
    add: add,
    updateItem: updateItem,
    removeItem: removeItem
  };
})();
